import { FC, Fragment } from 'react';

import { CloseIcon, SearchIcon } from '../../icons';
import Box from '../Box/Box';
import Button from '../Button/Button';
import { Flex } from '../Flex/Flex';
import { Text } from '../Text/Text';
import TextField from '../TextField/TextField';
import { messages } from './BulkActionsPanel.messages';
import { BulkActionsPanelProps } from './BulkActionsPanel.types';

export const BulkActionsPanel: FC<BulkActionsPanelProps> = (props) => {
    const { onEdit, onClone, onDelete, onClose, onSearchChange, selectedItemsCount, actions, searchValue } = props;

    return (
        <Box color='midnight20' radius='xsmall' spacing='8'>
            <Flex alignItems='center' spacing='0 40'>
                <Flex alignItems='center'>
                    <Button onClick={onClose} icon noPadding variant='text' color='blue100'>
                        <CloseIcon size={24} />
                    </Button>

                    <Text font='label' fontSize='small'>
                        {messages.itemsSelected({ count: selectedItemsCount })}
                    </Text>
                </Flex>

                {onSearchChange && (
                    <Flex grow={1} maxWidth={250}>
                        <TextField
                            value={searchValue}
                            onChange={onSearchChange}
                            size='small'
                            startIcon={<SearchIcon />}
                            placeholder={messages.searchPlaceholder}
                        />
                    </Flex>
                )}

                <Flex spacing='0 12'>
                    {onEdit && (
                        <Button size='small' variant='outline' onClick={onEdit} color='midnight40'>
                            {messages.edit}
                        </Button>
                    )}

                    {onClone && (
                        <Button size='small' variant='outline' onClick={onClone} color='midnight40'>
                            {messages.clone}
                        </Button>
                    )}

                    {onDelete && (
                        <Button size='small' onClick={onDelete} color='red40'>
                            {messages.delete}
                        </Button>
                    )}

                    {actions &&
                        actions.map((action, index) => <Fragment key={`custom-action-${index}`}>{action}</Fragment>)}
                </Flex>
            </Flex>
        </Box>
    );
};

BulkActionsPanel.displayName = 'BulkActionsPanel';
